import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="xmpmeta" id="xmpmeta"></a>
    <h1 {...{
      "id": "requireuxpxmpxmpmeta"
    }}>{`require('uxp').xmp.XMPMeta`}</h1>
    <p>{`XMPMeta
This class provides the core services of the XMP Toolkit. The functions provide the ability to create
and query metadata properties from an XMP namespace. The class also provides static functions
that allow you to create and query namespaces and aliases.`}</p>
    <p>{`There is one static property on the class that provides XMP version information; there are no
JavaScript properties in the instance. The object encapsulates a set of metadata properties, which
you access through the object functions.`}</p>
    <p>{`The generic functions `}<a parentName="p" {...{
        "href": "#getpropertyschemans-propname-valuetype"
      }}>{`getProperty()`}</a>{`, `}<a parentName="p" {...{
        "href": "#setpropertyschemans-propname-propvalue-setoptions-valuetype"
      }}>{`setProperty()`}</a>{`,
and `}<a parentName="p" {...{
        "href": "#deletepropertyschemans-propname"
      }}>{`deleteProperty()`}</a>{` allow you to manipulate alltypes of properties, when used with appropriately composed path expressions.
For convenience, the object also provides more specific functions for use with specific types of properties, such as arrays.`}</p>
    <p><strong parentName="p">{`Since`}</strong>{`: v7.2.0  `}</p>
    <a name="new-xmpmeta-new" id="new-xmpmeta-new"></a>
    <h2 {...{
      "id": "xmpmetapacket-buffer"
    }}>{`XMPMeta(packet, buffer)`}</h2>
    <p>{`To create an XMPMeta object, use the new operator. The constructor accepts an RDF/XML
serialized metadata packet as a string, or as an array of numbers that contain only byte values.
It returns the new object. If no argument is supplied, the new object is empty; you can use the
object’s functions to add namespaces and properties.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`packet`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A String containing an XML file or an XMP packet.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`buffer`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`An Array of Number. The UTF-8 or UTF-16 encoded bytes of an XML file or an XMP packet. This array is the result of XMPMeta.:ref:xmpmeta-serializeToArray.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// Create an XMPMeta object using property based APIs

let { XMPMeta, XMPConst } = require("uxp").xmp;
let meta = new XMPMeta();
meta.setProperty(XMPConst.NS_XMP, "Name", "vkumarg");
let prop = meta.getProperty(XMPConst.NS_XMP, "Name");
console.log(prop.namespace);
console.log(prop.options);
console.log(prop.path);
// checking for the property existence and deleting it
if(meta.doesPropertyExist(XMPConst.NS_XMP, "Name")) {
     meta.deleteProperty(XMPConst.NS_XMP, "Name");
}

if(!meta.doesPropertyExist(XMPConst.NS_XMP, "Name")) {
     console.log("Property doesn't exist");
} else {
     console.log("Property exists");
}
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// Create an XMPMeta object using struct based APIs

let { XMPDateTime, XMPMeta, XMPConst } = require("uxp").xmp;
let meta = new XMPMeta();

let jsDate = new Date("2007-04-10T17:54:50+01:00");
let xmpDate = new XMPDateTime(jsDate);
meta.setProperty(XMPConst.NS_XMP, "CreateDate", xmpDate, XMPConst.XMPDATE);
meta.doesPropertyExist(XMPConst.NS_XMP, "CreateDate");
let prop = meta.getProperty(XMPConst.NS_XMP, "CreateDate", XMPConst.XMPDATE);
meta.deleteProperty(XMPConst.NS_XMP, "CreateDate");

meta.setStructField(XMPConst.NS_XML, "structNameSample", XMPConst.NS_XMP, "sampleFieldName", "sampleFieldValue");
if (meta.doesStructFieldExist(XMPConst.NS_XML, "structNameSample", XMPConst.NS_XMP, "sampleFieldName")) {
     prop = meta.getStructField(XMPConst.NS_XML, "structNameSample", XMPConst.NS_XMP, "sampleFieldName");
     meta.deleteStructField(XMPConst.NS_XML, "structNameSample", XMPConst.NS_XMP, "sampleFieldName");
     if (meta.doesStructFieldExist(XMPConst.NS_XML, "structNameSample", XMPConst.NS_XMP, "sampleFieldName")) {
        console.log("Struct field exists");
    } else {
       console.log("Struct field doesn't exist");
   }
} else {
 console.log("Struct field doesn't exist");
}
`}</code></pre>
    <a name="xmpmeta-appendarrayitem" id="xmpmeta-appendarrayitem"></a>
    <h2 {...{
      "id": "appendarrayitemschemans-arrayname-itemvalue-itemoptions-arrayoptions"
    }}>{`appendArrayItem(schemaNS, arrayName, itemValue, `}{`[itemOptions]`}{`, `}{`[arrayOptions]`}{`)`}</h2>
    <p>{`Appends an item to an existing array, or creates a new array-type property if the named array does not exist.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`schemaNS`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The namespace URI string. See `}<a parentName="td" {...{
              "href": "./XMPConst.md#schema-namespace-string-constants"
            }}>{`Schema namespace string constants`}</a>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`arrayName`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The array-type property name string. Can be a general path expression.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`itemValue`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The new item value string. Pass null for array items that do not have values.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[itemOptions]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`0`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A flag that describes the new item, if it is being created. One of:`}<br></br>{` - 0: A simple item, or the type implied by the arrayOptions value.`}<br></br>{` - XMPConst.PROP_IS_ARRAY: The item is an array (of type alt, bag, or seq).`}<br></br>{` - XMPConst.PROP_IS_STRUCT: The item is a structure with nested fields.`}<br></br></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[arrayOptions]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`0`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A flag that describes the array form.  Must be provided if the array is being created; ignored if the array already exists. One of:`}<br></br>{` - XMPConst.ARRAY_IS_ORDERED: Item order is significant. Implies XMPConst.PROP_IS_Array`}<br></br>{` - XMPConst.ARRAY_IS_ALTERNATIVE: Items are mutually exclusive alternates. Implies XMPConst.PROP_IS_ARRAY and XMPConst.ARRAY_IS_ORDERED\``}<br></br></td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`XMPMetaObj.appendArrayItem(schemaNS, arrayName, itemValue[, itemOptions, arrayOptions])
`}</code></pre>
    <a name="xmpmeta-countarrayitems" id="xmpmeta-countarrayitems"></a>
    <h2 {...{
      "id": "countarrayitemsschemans-arrayname"
    }}>{`countArrayItems(schemaNS, arrayName)`}</h2>
    <p>{`Reports the number of items in an array-type metadata property.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`number`}</inlineCode>{` - the number of items  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`schemaNS`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The namespace URI string. See `}<a parentName="td" {...{
              "href": "./XMPConst.md#schema-namespace-string-constants"
            }}>{`Schema namespace string constants`}</a>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`arrayName`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The array-type property name string. Can be a general path expression.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`XMPMetaObj.countArrayItems(schemaNS, arrayName)
`}</code></pre>
    <a name="xmpmeta-deletearrayitem" id="xmpmeta-deletearrayitem"></a>
    <h2 {...{
      "id": "deletearrayitemschemans-arrayname-itemindex"
    }}>{`deleteArrayItem(schemaNS, arrayName, itemIndex)`}</h2>
    <p>{`Deletes the metadata tree that has the given array item as its root.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`schemaNS`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The namespace URI string. See `}<a parentName="td" {...{
              "href": "./XMPConst.md#schema-namespace-string-constants"
            }}>{`Schema namespace string constants`}</a>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`arrayName`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The array-type property name string. Can be a general path expression.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`itemIndex`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The 1-based position index of the item. Use XMPConst.ARRAY_LAST_ITEM to reference the last existing item in the array.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`XMPMetaObj.deleteArrayItem(schemaNS, arrayName, itemIndex)
`}</code></pre>
    <a name="xmpmeta-deleteproperty" id="xmpmeta-deleteproperty"></a>
    <h2 {...{
      "id": "deletepropertyschemans-propname"
    }}>{`deleteProperty(schemaNS, propName)`}</h2>
    <p>{`Deletes the metadata tree that has the given property as its root. If the property does not exist, does nothing.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`schemaNS`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The namespace URI string. See `}<a parentName="td" {...{
              "href": "./XMPConst.md#schema-namespace-string-constants"
            }}>{`Schema namespace string constants`}</a>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`propName`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The property name string. Can be a general path expression.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`XMPMetaObj.deleteProperty(schemaNS, propName)
`}</code></pre>
    <a name="xmpmeta-deletestructfield" id="xmpmeta-deletestructfield"></a>
    <h2 {...{
      "id": "deletestructfieldschemans-structname-fieldns-fieldname"
    }}>{`deleteStructField(schemaNS, structName, fieldNS, fieldName)`}</h2>
    <p>{`Deletes the metadata tree that has the given structure field as its root.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`schemaNS`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The namespace URI string. See `}<a parentName="td" {...{
              "href": "./XMPConst.md#schema-namespace-string-constants"
            }}>{`Schema namespace string constants`}</a>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`structName`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The structure name string. Can be a general path expression.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`fieldNS`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The field type namespace string. See `}<a parentName="td" {...{
              "href": "./XMPConst.md#schema-namespace-string-constants"
            }}>{`Schema namespace string constants`}</a>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`fieldName`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The field name string. Must be a simple XML name.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`XMPMetaObj.deleteStructField(schemaNS, structName, fieldNS, fieldName)
`}</code></pre>
    <a name="xmpmeta-deletequalifier" id="xmpmeta-deletequalifier"></a>
    <h2 {...{
      "id": "deletequalifierschemans-structname-qualns-qualname"
    }}>{`deleteQualifier(schemaNS, structName, qualNS, qualName)`}</h2>
    <p>{`Deletes the metadata tree that has the given qualifier as its root. If the qualifier does not exist, does nothing.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`schemaNS`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The namespace URI string. See `}<a parentName="td" {...{
              "href": "./XMPConst.md#schema-namespace-string-constants"
            }}>{`Schema namespace string constants`}</a>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`structName`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The structure name string. Can be a general path expression.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`qualNS`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The URI string of the qualifier namespace.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`qualName`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The qualifier name string. Must be a simple XML name.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`XMPMetaObj.deleteQualifier(schemaNS, structName, qualNS, qualName)
`}</code></pre>
    <a name="xmpmeta-doesarrayitemexist" id="xmpmeta-doesarrayitemexist"></a>
    <h2 {...{
      "id": "doesarrayitemexistschemans-arrayname-itemindex"
    }}>{`doesArrayItemExist(schemaNS, arrayName, itemIndex)`}</h2>
    <p>{`Reports whether an array item with a given index currently exists in an existing array in the metadata.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`boolean`}</inlineCode>{` - true if the array and item exist.  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`schemaNS`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The namespace URI string. See `}<a parentName="td" {...{
              "href": "./XMPConst.md#schema-namespace-string-constants"
            }}>{`Schema namespace string constants`}</a>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`arrayName`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The array name string. Can be a general path expression.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`itemIndex`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The 1-based position index of the item.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`XMPMetaObj.doesArrayItemExist(schemaNS, arrayName, itemIndex)
`}</code></pre>
    <a name="xmpmeta-doespropertyexist" id="xmpmeta-doespropertyexist"></a>
    <h2 {...{
      "id": "doespropertyexistschemans-propname"
    }}>{`doesPropertyExist(schemaNS, propName)`}</h2>
    <p>{`Reports whether a property with a given name currently exists in the metadata.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`boolean`}</inlineCode>{` - true if the property exists.  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`schemaNS`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The namespace URI string. See `}<a parentName="td" {...{
              "href": "./XMPConst.md#schema-namespace-string-constants"
            }}>{`Schema namespace string constants`}</a>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`propName`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The property name string. Can be a general path expression.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`XMPMetaObj.doesPropertyExist(schemaNS, propName)
`}</code></pre>
    <a name="xmpmeta-doesstructfieldexist" id="xmpmeta-doesstructfieldexist"></a>
    <h2 {...{
      "id": "doesstructfieldexistschemans-structname-fieldns-fieldname"
    }}>{`doesStructFieldExist(schemaNS, structName, fieldNS, fieldName)`}</h2>
    <p>{`Reports whether a structure field with a given name currently exists in the metadata.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`boolean`}</inlineCode>{` - true if the structure and field exist.  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`schemaNS`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The namespace URI string. See `}<a parentName="td" {...{
              "href": "./XMPConst.md#schema-namespace-string-constants"
            }}>{`Schema namespace string constants`}</a>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`structName`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The structure name string. Can be a general path expression.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`fieldNS`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The field type namespace string. See `}<a parentName="td" {...{
              "href": "./XMPConst.md#schema-namespace-string-constants"
            }}>{`Schema namespace string constants`}</a>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`fieldName`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The field name string. Must be a simple XML name.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`XMPMetaObj.doesStructFieldExist(schemaNS, structName, fieldNS, fieldName)
`}</code></pre>
    <a name="xmpmeta-doesqualifierexist" id="xmpmeta-doesqualifierexist"></a>
    <h2 {...{
      "id": "doesqualifierexistschemans-structname-qualns-qualname"
    }}>{`doesQualifierExist(schemaNS, structName, qualNS, qualName)`}</h2>
    <p>{`Reports whether a qualifier with a given name currently exists for a given property.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`boolean`}</inlineCode>{` - true if the property and qualifier exist.  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`schemaNS`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The namespace URI string. See `}<a parentName="td" {...{
              "href": "./XMPConst.md#schema-namespace-string-constants"
            }}>{`Schema namespace string constants`}</a>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`structName`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The structure name string. Can be a general path expression.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`qualNS`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The URI string of the qualifier namespace.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`qualName`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The qualifier name string. Must be a simple XML name.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`XMPMetaObj.doesQualifierExist(schemaNS, structName, qualNS, qualName)
`}</code></pre>
    <a name="xmpmeta-dumpobject" id="xmpmeta-dumpobject"></a>
    <h2 {...{
      "id": "dumpobject"
    }}>{`dumpObject()`}</h2>
    <p>{`Creates and returns a string containing the metadata content of this object as RDF.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`string`}</inlineCode>{` - a string containing the metadata content of this object as RDF.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`XMPMetaObj.dumpObject()
`}</code></pre>
    <a name="xmpmeta-getarrayitem" id="xmpmeta-getarrayitem"></a>
    <h2 {...{
      "id": "getarrayitemschemans-arrayname-itemindex"
    }}>{`getArrayItem(schemaNS, arrayName, itemIndex)`}</h2>
    <p>{`Retrieves an item from an array-type metadata property.
Returns an `}<a parentName="p" {...{
        "href": "./XMPProperty.md"
      }}>{`XMPProperty object`}</a>{`.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`XMPProperty`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="p">{`undefined`}</inlineCode>{` - the contents of the file.  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`schemaNS`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The namespace URI string. See `}<a parentName="td" {...{
              "href": "./XMPConst.md#schema-namespace-string-constants"
            }}>{`Schema namespace string constants`}</a>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`arrayName`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The array name string. Can be a general path expression.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`itemIndex`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The 1-based position index of the item. Use XMPConst.ARRAY_LAST_ITEM to reference the last existing item in the array.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`XMPMetaObj.getArrayItem(schemaNS, arrayName, itemIndex)
`}</code></pre>
    <a name="xmpmeta-getlocalizedtext" id="xmpmeta-getlocalizedtext"></a>
    <h2 {...{
      "id": "getlocalizedtextschemans-alttextname-genericlang-specificlang"
    }}>{`getLocalizedText(schemaNS, altTextName, genericLang, specificLang)`}</h2>
    <p>{`Retrieves the text value for a specific language from an alternate-text array. First tries to match the specific language.
If not found, tries to match the generic language, if specified. If not found, gets the x-default item, if any. Otherwise, gets the first item.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`string`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="p">{`undefined`}</inlineCode>{` - the text value for a specific language from an alternate-text array.  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`schemaNS`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The namespace URI string. See `}<a parentName="td" {...{
              "href": "./XMPConst.md#schema-namespace-string-constants"
            }}>{`Schema namespace string constants`}</a>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`altTextName`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The alternate-text array name string. Can be a general path expression.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`genericLang`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The name of the generic language as an RFC 3066 primary subtag. Can be null or the empty string.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`specificLang`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The name of the specific language as an RFC 3066 primary subtag; for example, en-US. Must be specified.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`XMPMetaObj.getLocalizedText(schemaNS, altTextName, genericLang, specificLang)
`}</code></pre>
    <a name="xmpmeta-getproperty" id="xmpmeta-getproperty"></a>
    <h2 {...{
      "id": "getpropertyschemans-propname-valuetype"
    }}>{`getProperty(schemaNS, propName, `}{`[valueType]`}{`)`}</h2>
    <p>{`Retrieves the value and options of a metadata property. Use for top-level, simple properties, or after using the path-composition functions in the `}<a parentName="p" {...{
        "href": "./XMPUtils.md"
      }}>{`XMPUtils object`}</a>{`.
Returns an `}<a parentName="p" {...{
        "href": "./XMPProperty.md"
      }}>{`XMPProperty object`}</a>{`.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`XMPProperty`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="p">{`undefined`}</inlineCode>{` - the value and options of a metadata property  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`schemaNS`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The namespace URI string. See `}<a parentName="td" {...{
              "href": "./XMPConst.md#schema-namespace-string-constants"
            }}>{`Schema namespace string constants`}</a>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`propName`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The property name string. Can be a general path expression.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[valueType]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`&quot;\\&quot;\\&quot;&quot;`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The property data type, one of: - XMPConst.STRING - XMPConst.INTEGER - XMPConst.NUMBER - XMPConst.BOOLEAN - XMPConst.XMPDATE`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`XMPMetaObj.getProperty(schemaNS, propName[, valueType])
`}</code></pre>
    <a name="xmpmeta-getstructfield" id="xmpmeta-getstructfield"></a>
    <h2 {...{
      "id": "getstructfieldschemans-structname-fieldns-fieldname"
    }}>{`getStructField(schemaNS, structName, fieldNS, fieldName)`}</h2>
    <p>{`Retrieves a field value from within a nested structure in metadata.
Returns an `}<a parentName="p" {...{
        "href": "./XMPProperty.md"
      }}>{`XMPProperty object`}</a>{`.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`XMPProperty`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="p">{`undefined`}</inlineCode>{` - the field value from within a nested structure in metadata.  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`schemaNS`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The namespace URI string. See `}<a parentName="td" {...{
              "href": "./XMPConst.md#schema-namespace-string-constants"
            }}>{`Schema namespace string constants`}</a>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`structName`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The structure name string. Can be a general path expression.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`fieldNS`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The field type namespace string. See `}<a parentName="td" {...{
              "href": "./XMPConst.md#schema-namespace-string-constants"
            }}>{`Schema namespace string constants`}</a>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`fieldName`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The field name string. Must be a simple XML name.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`XMPMetaObj.getStructField(schemaNS, structName, fieldNS, fieldName)
`}</code></pre>
    <a name="xmpmeta-getqualifier" id="xmpmeta-getqualifier"></a>
    <h2 {...{
      "id": "getqualifierschemans-structname-qualns-qualname"
    }}>{`getQualifier(schemaNS, structName, qualNS, qualName)`}</h2>
    <p>{`Retrieves a qualifier attached to a metadata property.
Returns an `}<a parentName="p" {...{
        "href": "./XMPProperty.md"
      }}>{`XMPProperty object`}</a>{`.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`XMPProperty`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="p">{`undefined`}</inlineCode>{` - the qualifier attached to a metadata property  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`schemaNS`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The namespace URI string. See `}<a parentName="td" {...{
              "href": "./XMPConst.md#schema-namespace-string-constants"
            }}>{`Schema namespace string constants`}</a>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`structName`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The structure name string. Can be a general path expression.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`qualNS`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The URI string of the qualifier namespace.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`qualName`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The qualifier name string. Must be a simple XML name.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`XMPMetaObj.getQualifier(schemaNS, structName, qualNS, qualName)
`}</code></pre>
    <a name="xmpmeta-insertarrayitem" id="xmpmeta-insertarrayitem"></a>
    <h2 {...{
      "id": "insertarrayitemschemans-arrayname-itemindex-itemvalue-itemoptions"
    }}>{`insertArrayItem(schemaNS, arrayName, itemIndex, itemValue, `}{`[itemOptions]`}{`)`}</h2>
    <p>{`Inserts an item into an array, before an existing item. The index positions of all later items are incremented. The array must exist.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`schemaNS`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The namespace URI string. See `}<a parentName="td" {...{
              "href": "./XMPConst.md#schema-namespace-string-constants"
            }}>{`Schema namespace string constants`}</a>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`arrayName`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The array-type property name string. Can be a general path expression.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`itemIndex`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The 1-based position index at which to insert the new item. Use XMPConst.ARRAY_LAST_ITEM to reference the last existing item in the array.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`itemValue`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The new item value. Pass null for array items that do not have values.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[itemOptions]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`0`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A flag that describes the new item, if it is being created. One of:`}<br></br>{` - 0: A simple item, the default.`}<br></br>{` - XMPConst.PROP_IS_ARRAY: The item is an array (of type alt, bag, or seq).`}<br></br>{` - XMPConst.PROP_IS_STRUCT: The item is a structure with nested fields.`}<br></br></td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`XMPMetaObj.insertArrayItem(schemaNS, arrayName, itemIndex, itemValue[, itemOptions])
`}</code></pre>
    <a name="xmpmeta-iterator" id="xmpmeta-iterator"></a>
    <h2 {...{
      "id": "iteratoroptions-schemans-propname"
    }}>{`iterator(options, schemaNS, propName)`}</h2>
    <p>{`Creates an iteration object that can iterate over the properties, arrays, and qualifiers within this metadata.
Specify options, a namespace, and a property to limit the range and granularity of the resulting items.
Returns an `}<a parentName="p" {...{
        "href": "./XMPIterator.md"
      }}>{`XMPIterator object`}</a>{`.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`XMPIterator`}</inlineCode>{` - the XMPIterator object for this metadata object  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`options`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`0`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The set of options that control how the iteration is performed, and how values are returned. A logical OR of these bit-flag constants:`}<br></br>{` XMPConst.ITERATOR_JUST_CHILDREN - Limit iteration to immediate children of the root property. By default, iterates into subtrees.`}<br></br>{` XMPConst.ITERATOR_JUST_LEAFNODES - Limit iteration to leaf nodes. By default, iterates into all nodes of a subtree.`}<br></br>{` XMPConst.ITERATOR_JUST_LEAFNAMES - Return only the leaf part of the path. By default, returns a full path.`}<br></br>{` XMPConst.ITERATOR_INCLUDE_ALIASES - Include aliases. By default, considers only actual properties.`}<br></br>{` XMPConst.ITERATOR_OMIT_QUALIFIERS - Omit qualifiers from iteration.`}<br></br></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`schemaNS`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The namespace URI string. See `}<a parentName="td" {...{
              "href": "./XMPConst.md#schema-namespace-string-constants"
            }}>{`Schema namespace string constants`}</a>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`propName`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The array-type property name string. Can be a general path expression.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`XMPMetaObj.iterator(options, schemaNS, propName)
`}</code></pre>
    <a name="xmpmeta-serialize" id="xmpmeta-serialize"></a>
    <h2 {...{
      "id": "serializeoptions-padding-indent-newline-baseindent"
    }}>{`serialize(`}{`[options]`}{`, `}{`[padding]`}{`, `}{`[indent]`}{`, `}{`[newline]`}{`, `}{`[baseIndent]`}{`)`}</h2>
    <p>{`Serializes this XMP metadata into a string as RDF.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`string`}</inlineCode>{` - the serialized XMP metadata as a RDF string  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[options]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`0`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The set of options that control how the serialization is performed. The options must be logically consistent; if they conflict, the function throws an exception. A logical OR of these bit-flag constants:`}<br></br>{` XMPConst.SERIALIZE_OMIT_PACKET_WRAPPER - Do not include an XML packet wrapper.`}<br></br>{` XMPConst.SERIALIZE_READ_ONLY_PACKET - Create a read-only XML packet wrapper.`}<br></br>{` XMPConst.SERIALIZE_USE_COMPACT_FORMAT - Use a highly compact RDF syntax and layout.`}<br></br>{` XMPConst.SERIALIZE_USE_PLAIN_XMP - Serialize a plain XMP (not currently supported).`}<br></br>{` XMPConst.SERIALIZE_INCLUDE_THUMBNAIL_PAD - Include typical space for a JPEG thumbnail in the padding if no xmp:Thumbnail property is present.`}<br></br>{` XMPConst.SERIALIZE_EXACT_PACKET_LENGTH - Compute padding to meet the overall packet length provided by the padding parameter. Throws an exception if the unpadded packet exceeds this length.`}<br></br>{` XMPConst.SERIALIZE_WRITE_ALIAS_COMMENTS - Include XML comments for aliases.`}<br></br></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[padding]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`0`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`If the options value is SERIALIZE_EXACT_PACKET_LENGTH, this the exact length of the packet, including padding characters that are added to meet this length. If the options value is not SERIALIZE_EXACT_PACKET_LENGTH, this is a number of padding characters to add.Default is 0, meaning to use the appropriate amount of padding.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[indent]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`&quot;\\&quot;  \\&quot;&quot;`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The string to use as an indent. Default is two spaces.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[newline]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`&quot;\\&quot;U+000A\\&quot;&quot;`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The newline character to use.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[baseIndent]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`0`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The level of indentation of the outermost XML element.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`XMPMetaObj.serialize([options, padding, indent, newline, baseIndent])
`}</code></pre>
    <a name="xmpmeta-serializetoarray" id="xmpmeta-serializetoarray"></a>
    <h2 {...{
      "id": "serializetoarrayoptions-padding-indent-newline-baseindent"
    }}>{`serializeToArray(`}{`[options]`}{`, `}{`[padding]`}{`, `}{`[indent]`}{`, `}{`[newline]`}{`, `}{`[baseIndent]`}{`)`}</h2>
    <p>{`Serializes this XMP metadata into a string as RDF, then converts that to an array of one-byte numeric values, the UTF-8 or UTF-16 encoded characters.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Array`}</inlineCode>{` - the Array of Numbers.  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[options]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`0`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The set of options that control how the serialization is performed. The options must be logically consistent; if they conflict, the function throws an exception. A logical OR of these bit-flag constants:`}<br></br>{` XMPConst.SERIALIZE_OMIT_PACKET_WRAPPER - Do not include an XML packet wrapper.`}<br></br>{` XMPConst.SERIALIZE_READ_ONLY_PACKET - Create a read-only XML packet wrapper.`}<br></br>{` XMPConst.SERIALIZE_USE_COMPACT_FORMAT - Use a highly compact RDF syntax and layout.`}<br></br>{` XMPConst.SERIALIZE_USE_PLAIN_XMP - Serialize a plain XMP (not currently supported).`}<br></br>{` XMPConst.SERIALIZE_INCLUDE_THUMBNAIL_PAD - Include typical space for a JPEG thumbnail in the padding if no xmp:Thumbnail property is present.`}<br></br>{` XMPConst.SERIALIZE_EXACT_PACKET_LENGTH - Compute padding to meet the overall packet length provided by the padding parameter. Throws an exception if the unpadded packet exceeds this length.`}<br></br>{` XMPConst.SERIALIZE_WRITE_ALIAS_COMMENTS - Include XML comments for aliases.`}<br></br></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[padding]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`0`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`If the options value is SERIALIZE_EXACT_PACKET_LENGTH, this the exact length of the packet, including padding characters that are added to meet this length. If the options value is not SERIALIZE_EXACT_PACKET_LENGTH, this is a number of padding characters to add. Default is 0, meaning to use the appropriate amount of padding.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[indent]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`&quot;\\&quot;  \\&quot;&quot;`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The string to use as an indent. Default is two spaces.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[newline]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`&quot;\\&quot;U+000A\\&quot;&quot;`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The newline character to use.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[baseIndent]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`0`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The level of indentation of the outermost XML element.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`XMPMetaObj.serializeToArray([options, padding, indent, newline, baseIndent])
`}</code></pre>
    <a name="xmpmeta-setarrayitem" id="xmpmeta-setarrayitem"></a>
    <h2 {...{
      "id": "setarrayitemschemans-arrayname-itemindex-itemvalue-itemoptions"
    }}>{`setArrayItem(schemaNS, arrayName, itemIndex, itemValue, `}{`[itemOptions]`}{`)`}</h2>
    <p>{`Replaces an item within an array, or appends an item. The array must exist. To create an item, appendArrayItem() and insertArrayItem() are preferred.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`schemaNS`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The namespace URI string. See `}<a parentName="td" {...{
              "href": "./XMPConst.md#schema-namespace-string-constants"
            }}>{`Schema namespace string constants`}</a>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`arrayName`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The array-type property name string. Can be a general path expression.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`itemIndex`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The 1-based position index of the item. Use XMPConst.ARRAY_LAST_ITEM to reference the last existing item in the array.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`itemValue`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The new item value string. Pass null for array items that do not have values.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[itemOptions]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`0`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A flag that describes the new item, if it is being created. One of:`}<br></br>{` - 0: A simple item, or the type implied by the arrayOptions value.`}<br></br>{` - XMPConst.PROP_IS_ARRAY: The item is an array (of type alt, bag, or seq).`}<br></br>{` - XMPConst.PROP_IS_STRUCT: The item is a structure with nested fields.`}<br></br></td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`XMPMetaObj.setArrayItem(schemaNS, arrayName, itemIndex, itemValue[, itemOptions])
`}</code></pre>
    <a name="xmpmeta-setlocalizedtext" id="xmpmeta-setlocalizedtext"></a>
    <h2 {...{
      "id": "setlocalizedtextschemans-alttextname-genericlang-specificlang-itemvaluethe"
    }}>{`setLocalizedText(schemaNS, altTextName, genericLang, specificLang, itemValueThe)`}</h2>
    <p>{`Sets the text value for a specific language in an alternate-text array. Handles special cases for the x-default item.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`schemaNS`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The namespace URI string. See `}<a parentName="td" {...{
              "href": "./XMPConst.md#schema-namespace-string-constants"
            }}>{`Schema namespace string constants`}</a>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`altTextName`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The name string of the alternate-text array. Can be a general path expression.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`genericLang`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The name of the generic language as an RFC 3066 primary subtag. Can be null or the empty string.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`specificLang`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The name of the specific language as an RFC 3066 primary subtag; for example, en-US. Must be specified.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`itemValueThe`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`new string value.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`XMPMetaObj.setLocalizedText(schemaNS, altTextName, genericLang, specificLang, itemValue, setOptions)
`}</code></pre>
    <a name="xmpmeta-setstructfield" id="xmpmeta-setstructfield"></a>
    <h2 {...{
      "id": "setstructfieldschemans-structname-fieldns-fieldname-fieldvalue-options"
    }}>{`setStructField(schemaNS, structName, fieldNS, fieldName, fieldValue, `}{`[options]`}{`)`}</h2>
    <p>{`Sets the value of a field within a structure-type property, or creates a new field if the named field does not exist in the structure,
or creates a new structure containing the named field if the named structure does not exist.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`schemaNS`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The namespace URI string. See `}<a parentName="td" {...{
              "href": "./XMPConst.md#schema-namespace-string-constants"
            }}>{`Schema namespace string constants`}</a>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`structName`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The name string of an existing structure. Can be a general path expression.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`fieldNS`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The field type namespace string. See `}<a parentName="td" {...{
              "href": "./XMPConst.md#schema-namespace-string-constants"
            }}>{`Schema namespace string constants`}</a>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`fieldName`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The field name string. Must be a simple XML name.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`fieldValue`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`he new field value string. Pass null for fields that do not have values.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[options]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`0`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`option flags that describe a new structure. Used only if the structure is being created. One of:`}<br></br>{` - 0: A simple item, the default.`}<br></br>{` - XMPConst.PROP_IS_ARRAY: The item is an array (of type alt, bag, or seq).`}<br></br>{` - XMPConst.PROP_IS_STRUCT: The item is a structure with nested fields.`}<br></br></td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`XMPMetaObj.setStructField(schemaNS, structName, fieldNS, fieldName, fieldValue[, options])
`}</code></pre>
    <a name="xmpmeta-setqualifier" id="xmpmeta-setqualifier"></a>
    <h2 {...{
      "id": "setqualifierschemans-propname-qualns-qualname-qualvalue-options"
    }}>{`setQualifier(schemaNS, propName, qualNS, qualName, qualValue, `}{`[options]`}{`)`}</h2>
    <p>{`Attaches a new qualifier to a metadata property. A qualifier can be added to a simple property, an array item, a struct field, or another qualifier.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`schemaNS`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The namespace URI string. See `}<a parentName="td" {...{
              "href": "./XMPConst.md#schema-namespace-string-constants"
            }}>{`Schema namespace string constants`}</a>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`propName`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The name string of an existing property. Can be a general path expression.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`qualNS`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The URI of the qualifier namespace. Has the same URI and prefix usage as a schema namespace.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`qualName`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The name of the qualifier. Must be a simple XML name. Has the same prefix usage as a property name.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`qualValue`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The new qualifier value string. Pass null for qualifiers that do not have values.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[options]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`0`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`option flags that describe a new structure. Used only if the structure is being created. One of:`}<br></br>{` - 0: A simple item, the default.`}<br></br>{` - XMPConst.PROP_IS_ARRAY: The item is an array (of type alt, bag, or seq).`}<br></br>{` - XMPConst.PROP_IS_STRUCT: The item is a structure with nested fields.`}<br></br></td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`XMPMetaObj.setQualifier(schemaNS, propName, qualNS, qualName, qualValue[, options])
`}</code></pre>
    <a name="xmpmeta-setproperty" id="xmpmeta-setproperty"></a>
    <h2 {...{
      "id": "setpropertyschemans-propname-propvalue-setoptions-valuetype"
    }}>{`setProperty(schemaNS, propName, propValue, `}{`[setOptions]`}{`, `}{`[valueType]`}{`)`}</h2>
    <p>{`Sets the value of a simple metadata property, creating the property if necessary, or creates a new array or structure property.
For creating array and structure properties,  `}<a parentName="p" {...{
        "href": "#setarrayitemschemans-arrayname-itemindex-itemvalue-itemoptions"
      }}>{`setArrayItem()`}</a>{` and `}<a parentName="p" {...{
        "href": "#setstructfieldschemans-structname-fieldns-fieldname-fieldvalue-options"
      }}>{`setStructField()`}</a>{` are preferred.
Use this call to create or set top-level, simple properties, or after using the path-composition functions in the `}<a parentName="p" {...{
        "href": "./XMPUtils.md"
      }}>{`[XMPUtils object](./XMPUtils.md)`}</a>{`.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`schemaNS`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The namespace URI string. See `}<a parentName="td" {...{
              "href": "./XMPConst.md#schema-namespace-string-constants"
            }}>{`Schema namespace string constants`}</a>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`propName`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The property name string. Can be a general path expression.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`propValue`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The new property value string. Pass null to create an array or non-leaf level structure property.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[setOptions]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`0`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`option flags that describe a new structure. Used only if the structure is being created. One of:`}<br></br>{` - 0: A simple item, the default.`}<br></br>{` - XMPConst.PROP_IS_ARRAY: The item is an array (of type alt, bag, or seq).`}<br></br>{` - XMPConst.PROP_IS_STRUCT: The item is a structure with nested fields.`}<br></br></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[valueType]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`&quot;\\&quot;\\&quot;&quot;`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The property data type, If supplied, the value is converted to this type. one of: `}<br></br>{` - XMPConst.STRING`}<br></br>{`         - XMPConst.INTEGER`}<br></br>{`         - XMPConst.NUMBER`}<br></br>{`         - XMPConst.BOOLEAN`}<br></br>{`         - XMPConst.XMPDATE`}<br></br></td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`XMPMetaObj.setProperty(schemaNS, propName, propValue[, setOptions, valueType])
`}</code></pre>
    <a name="xmpmeta-sort" id="xmpmeta-sort"></a>
    <h2 {...{
      "id": "sort"
    }}>{`sort()`}</h2>
    <p>{`Sorts the XMP contents alphabetically. At the top level, sorts namespaces by their prefixes.
Within a namespace, sorts top-level properties are sorted by name. Within a struct, sorts fields by their qualified name (that is, the XML prefix:local form.)
Sorts unordered arrays of simple items by value. Sorts language alternative arrays by the xml:lang qualifiers, with the "x-default" item placed first.`}</p>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`XMPMetaObj.sort()
`}</code></pre>
    <a name="xmpmeta-deletenamespace" id="xmpmeta-deletenamespace"></a>
    <h2 {...{
      "id": "deletenamespacenamespaceuri"
    }}>{`deleteNamespace(namespaceURI)`}</h2>
    <p>{`Deletes a registered prefix - namespace URI pair.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`namespaceURI`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The namespace URI string. See `}<a parentName="td" {...{
              "href": "./XMPConst.md#schema-namespace-string-constants"
            }}>{`Schema namespace string constants`}</a>{`.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`XMPMeta.deleteNamespace(namespaceURI)
`}</code></pre>
    <a name="xmpmeta-dumpnamespaces" id="xmpmeta-dumpnamespaces"></a>
    <h2 {...{
      "id": "dumpnamespacesnamespaceuri"
    }}>{`dumpNamespaces(namespaceURI)`}</h2>
    <p>{`Creates and returns a human-readable string containing the list of registered namespace URIs and their associated prefixes.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`string`}</inlineCode>{` - the list of registered namespace URIs and their associated prefixes.  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`namespaceURI`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The namespace URI string. See `}<a parentName="td" {...{
              "href": "./XMPConst.md#schema-namespace-string-constants"
            }}>{`Schema namespace string constants`}</a>{`.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`XMPMeta.dumpNamespaces()
`}</code></pre>
    <a name="xmpmeta-getnamespaceprefix" id="xmpmeta-getnamespaceprefix"></a>
    <h2 {...{
      "id": "getnamespaceprefixnamespaceuri"
    }}>{`getNamespacePrefix(namespaceURI)`}</h2>
    <p>{`Retrieves the prefix associated with a registered namespace URI.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`string`}</inlineCode>{` - the prefix string followed by a colon.  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`namespaceURI`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The namespace URI string. See `}<a parentName="td" {...{
              "href": "./XMPConst.md#schema-namespace-string-constants"
            }}>{`Schema namespace string constants`}</a>{`.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`XMPMeta.getNamespacePrefix(namespaceURI)
`}</code></pre>
    <a name="xmpmeta-getnamespaceuri" id="xmpmeta-getnamespaceuri"></a>
    <h2 {...{
      "id": "getnamespaceurinamespaceprefix"
    }}>{`getNamespaceURI(namespacePrefix)`}</h2>
    <p>{`Retrieves the registered namespace URI associated with a namespace prefix.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`string`}</inlineCode>{` - the URI String.  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`namespacePrefix`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The namespace prefix string.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`XMPMeta.getNamespaceURI(namespacePrefix)
`}</code></pre>
    <a name="xmpmeta-registernamespace" id="xmpmeta-registernamespace"></a>
    <h2 {...{
      "id": "registernamespacenamespaceuri-suggestedprefix"
    }}>{`registerNamespace(namespaceURI, suggestedPrefix)`}</h2>
    <p>{`Registers a namespace with a prefix. If the suggested prefix is already in use, generates, registers,
and returns a different prefix.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`string`}</inlineCode>{` - the String containing the actual registered prefix. This is the suggestedPrefix, unless that one is already assigned to another namespace.  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`namespaceURI`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The namespace URI string. See `}<a parentName="td" {...{
              "href": "./XMPConst.md#schema-namespace-string-constants"
            }}>{`Schema namespace string constants`}</a>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`suggestedPrefix`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The suggested namespace prefix string.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`XMPMeta.registerNamespace(namespaceURI, suggestedPrefix)
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      